export const languagesList = [
  { id: 0, label: "Any", value: "" },
  {
    id: "en",
    value: "en",
    label: "English",
  },
  {
    id: "zh",
    value: "zh",
    label: "Chinese",
  },
  {
    id: "es",
    value: "es",
    label: "Spanish",
  },
  {
    id: "hi",
    value: "hi",
    label: "Hindi",
  },
  {
    id: "pt",
    value: "pt",
    label: "Portuguese",
  },
  {
    id: "fr",
    value: "fr",
    label: "French",
  },
  {
    id: "de",
    value: "de",
    label: "German",
  },
  {
    id: "ja",
    value: "ja",
    label: "Japanese",
  },
  {
    id: "ar",
    value: "ar",
    label: "Arabic",
  },
  {
    id: "ru",
    value: "ru",
    label: "Russian",
  },
  {
    id: "ko",
    value: "ko",
    label: "Korean",
  },
  {
    id: "id",
    value: "id",
    label: "Indonesian",
  },
  {
    id: "it",
    value: "it",
    label: "Italian",
  },
  {
    id: "nl",
    value: "nl",
    label: "Dutch",
  },
  {
    id: "tr",
    value: "tr",
    label: "Turkish",
  },
  {
    id: "pl",
    value: "pl",
    label: "Polish",
  },
  {
    id: "sv",
    value: "sv",
    label: "Swedish",
  },
  {
    id: "fil",
    value: "fil",
    label: "Filipino",
  },
  {
    id: "ms",
    value: "ms",
    label: "Malay",
  },
  {
    id: "ro",
    value: "ro",
    label: "Romanian",
  },
  {
    id: "uk",
    value: "uk",
    label: "Ukrainian",
  },
  {
    id: "el",
    value: "el",
    label: "Greek",
  },
  {
    id: "cs",
    value: "cs",
    label: "Czech",
  },
  {
    id: "da",
    value: "da",
    label: "Danish",
  },
  {
    id: "fi",
    value: "fi",
    label: "Finnish",
  },
  {
    id: "bg",
    value: "bg",
    label: "Bulgarian",
  },
  {
    id: "hr",
    value: "hr",
    label: "Croatian",
  },
  {
    id: "sk",
    value: "sk",
    label: "Slovak",
  },
  {
    id: "ta",
    value: "ta",
    label: "Tamil",
  },
  {
    id: "hu",
    value: "hu",
    label: "Hungarian",
  },
  {
    id: "no",
    value: "no",
    label: "Norwegian",
  },
  {
    id: "vi",
    value: "vi",
    label: "Vietnamese",
  },
];

export const languages = {
  en: "English",
  zh: "Chinese",
  es: "Spanish",
  hi: "Hindi",
  pt: "Portuguese",
  fr: "French",
  de: "German",
  ja: "Japanese",
  ar: "Arabic",
  ru: "Russian",
  ko: "Korean",
  id: "Indonesian",
  it: "Italian",
  nl: "Dutch",
  tr: "Turkish",
  pl: "Polish",
  sv: "Swedish",
  fil: "Filipino",
  ms: "Malay",
  ro: "Romanian",
  uk: "Ukrainian",
  el: "Greek",
  cs: "Czech",
  da: "Danish",
  fi: "Finnish",
  bg: "Bulgarian",
  hr: "Croatian",
  sk: "Slovak",
  ta: "Tamil",
  hu: "Hungarian",
  no: "Norwegian",
  vi: "Vietnamese",
};
